import '../styles/nav.css';
import logo_1 from '../imgs/logo_1.png';
import { NavLink } from 'react-router-dom';






export default function Navbar() {

   
     
    return (

        <nav className="nav">
                <ul>
                <li className="logo"><img src={logo_1} alt="Logo" width="100" height="100" /></li>
                    <li><NavLink to="/">Home</NavLink></li>
                    <li><NavLink to="/apps">Apps</NavLink></li>
                    <li><NavLink to="/contact">Contact</NavLink></li>
                </ul>              
        </nav>

     
    );
}

